import { useMemo } from 'react'
import {
  MapContainer,
  TileLayer,
  Marker,
  LayersControl,
  ZoomControl,
} from 'react-leaflet'
import { isMobile, getLanguage } from '../../utils'
import { getMapTileUrl, isMainLand, tiandituTilesUrl } from 'config'

const redIcon = new window.L.Icon({
  iconUrl: `${window.staticPath}travel_dist/images/marker.png`,
  iconRetinaUrl: `${window.staticPath}travel_dist/images/marker.png`,
  iconSize: [23, 30],
})

const language = getLanguage()
const isMobileDevice = isMobile()

export default function NavigationMap({
  onDragEnd,
  latitude = 50,
  longitude = 30,
  isDraggable = true,
  countryCode,
}) {
  const lat = /^(-?\d+(\.\d+)?)$/.test(latitude) ? latitude : 50
  const lng = /^(-?\d+(\.\d+)?)$/.test(longitude) ? longitude : 30

  const tileUrl = useMemo(
    () =>
      getMapTileUrl({
        isSateliteView: false,
        countryCode,
        language,
        isLight: true,
      }),
    [language]
  )

  return (
    <div className='relative mbm'>
      <MapContainer
        zoomControl={false}
        center={[lat, lng]}
        zoom={7}
        style={{ width: '100%', height: '400px' }}
        scrollWheelZoom={false}
        tap={!isMobileDevice}
        touchZoom={isMobileDevice}
        dragging={!isMobileDevice}
      >
        <LayersControl position='topright'>
          <LayersControl.BaseLayer name='PADI Travel map' checked>
            {isMainLand(countryCode) && <TileLayer url={tiandituTilesUrl} />}
            <TileLayer url={tileUrl} />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name='Satellite'>
            <TileLayer url='//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' />
          </LayersControl.BaseLayer>
        </LayersControl>
        <ZoomControl position='topright' />
        <Marker
          draggable={isDraggable}
          position={[lat, lng]}
          ondragend={(e) => onDragEnd(e.target.getLatLng())}
          icon={redIcon}
        />
      </MapContainer>
    </div>
  )
}
